import { useState } from 'react';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { Checkbox } from '../Checkbox';
import { StyledBottomContainer, StyledContainer } from './Info.styled';

const Info = ({ img }: { img?: boolean }) => {
	const helpModal = useObservable(rage.helpModal.getActiveModal());
	const [checked, setChecked] = useState(false);

	const handleReply = () => {
		rage.helpModal
			.replyToHelpModal(checked)
			.catch((err) => rage.notifications.showException(err));
	};

	return (
		<StyledContainer>
			<Text style={{ fontSize: 16, fontWeight: 700, color: '#FFFFFF' }}>
				{helpModal?.title}
			</Text>
			<Text
				style={{
					fontSize: 14,
					color: '#FFFFFF',
					opacity: 0.5,
					minHeight: 161,
					marginTop: 10,
				}}
			>
				{helpModal?.text}
			</Text>
			<StyledBottomContainer>
				<Checkbox
					value={checked}
					onChange={setChecked}
					text={img ? 'Не показывать снова' : 'Не показывать подсказку снова'}
				/>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height40}
					style={{ width: 130 }}
					onClick={handleReply}
				>
					<Text>Продолжить</Text>
				</Button>
			</StyledBottomContainer>
		</StyledContainer>
	);
};

export { Info };
